import React, { useEffect, useState } from "react";
import { Box, List, TextField, Typography } from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemButton from '@mui/material/ListItemButton';
import clsx from "clsx";
import Collapse from "@material-ui/core/Collapse";

import ListItemIcon from "@material-ui/core/ListItemIcon";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from "@material-ui/core/IconButton";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#ff4717",
  },
  mb: {
    marginTop: "15px",
  },
  root: {
    display: "flex",
    padding: "0px",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: "65px",
    height: "100vh",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "white",
  },
  theadingstyles: {
    background: "rgb(26 26 49)",
    padding: "12px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    color: "white",
    fontSize: "16px",
  },

  activeListColor: {
    color: "#ff4717 !important",
  },
 
  shiplist: {
    "&.Mui-selected .MuiListItemText-root span": {
      color: "#ff4717 !important",
    },   
    
},
  active: {
    "& span": {
      color: "#ff4717 !important",
    }
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  pointer: {
    cursor: "pointer"
  },
  shiptext:{
    margin:"10px",
  },
  shipIcon:{
    marginLeft:"90px"
  },
  shipbox:{
    "&.MuiListItem-gutters":{
      paddingLeft:"0px"

    }
  }
  // shiptext:{
  //   whiteSpace:"nowrap",
  //   width:"70px",
  //   overflow:"hidden",
  //   textOverflow:"clip"
  // }
}));

export default function RowShip(props) {
  const classes = useStyles();
  const { rows, setTransformerSelectedId, transformerListequip, selectedEquimentKey, setSelectedEquimentKey} = props;
  const [open, setOpen] = React.useState(false);
 


  const transformerSelectedId = (data, row, shipRow) => {   //single Select Shiplist function
    debugger
    let equimentKeyActive = selectedEquimentKey;
    let transArryList = transformerListequip;
    
    let transKeyIndex = transArryList.findIndex(i => i.shipId == shipRow.shipId && i.equimentId == row.equimentId)

    if (transKeyIndex == -1) {
      transArryList.push({ ...row, shipId: shipRow.shipId, shipName: shipRow.shipName });
    } else {
      transArryList.splice(transKeyIndex, 1);
    }

    let equimentKeyIndex = equimentKeyActive.indexOf(data);
    if (equimentKeyIndex == -1) {
      equimentKeyActive.push(data);
    } else {
      equimentKeyActive.splice(equimentKeyIndex, 1);
    }
   
    setSelectedEquimentKey(equimentKeyActive);
    setTransformerSelectedId(equimentKeyActive, transArryList);
  

  }

  const transformerSelectedIdNew = (Alldata, event) => {    //Multiple Select Shiplist function
    var ischecked = event.target.checked
    let equimentKeyActive =  selectedEquimentKey; //selectedEquimentKeynew
    let transArryList = transformerListequip;

    let CheckBoxData = []
    let transArryListnew = []
   
    if(ischecked == true)
    {
      setOpen(open)
    }
    if(ischecked == false)
    {
      setOpen()
    }

    CheckBoxData.push(Alldata)
    let CurrentshipId = CheckBoxData.map((item) => {
      return item.shipId
    })
   
    let modified =[];
    let  equimentKeyActivenew =[];
    CheckBoxData.forEach((data) => {
      if (data.equimentList) {
       let result = data.equimentList.map((item) => {
       return item.equimentId
        })
        modified=[...result]
      }
     console.log(modified);
    })

    equimentKeyActive.map((item)=>{
      let exist = modified.includes(item)
      if (exist == false) {
        equimentKeyActivenew.push(item);
      
      }
    })
    transArryList.map((item) => {
      let exist = CurrentshipId.includes(item.shipId)
      if (exist == false) {
        transArryListnew.push(item)
      }
})

    let transKeyIndex = transArryListnew.findIndex((i) => i.shipId == Alldata.shipId)
    let array = []
    if (ischecked) {
      if (transKeyIndex == -1) {
        array.push(Alldata)
        array.forEach((data) => {
          data.equimentList.map((item) => {
            transArryListnew.push({ shipId: data.shipId, shipName: data.shipName, equimentName: item.equimentName, equimentId: item.equimentId })
          })
          console.log(transArryList);
        })
        Alldata.equimentList.map((value) => {
          equimentKeyActivenew.push(value.equimentId)
        })
      }
    }
    else {
      transArryListnew = transArryListnew.filter(item => item.shipId !== Alldata.shipId)
      equimentKeyActivenew = equimentKeyActivenew.filter(item => item.shipId !== Alldata.shipId)
      // Alldata.equimentList.map((value) => {
      //   let equimentKeyIndex = equimentKeyActivenew.indexOf(value.equimentId)
      //   equimentKeyActivenew.splice(equimentKeyIndex, 1)
      // })
    }
    setSelectedEquimentKey(equimentKeyActive);
    setTransformerSelectedId(equimentKeyActivenew, transArryListnew, 'checkboxSelect', ischecked);
  }



 
  const handleClick = () => {
    debugger
    setOpen(!open)
  }

  return (
    <div>
      <Box component="nav" className={clsx(classes.scroll)+"scroll-list-lube"} >
        <Box key={rows.shipName} textAlign="right"
          className={clsx(classes.shiplist, "shiplist")}
            >
            <ListItem>
            <ListItemButton>
            <Checkbox onChange={(event) => {
              transformerSelectedIdNew(rows, event)
            }} size="small"/>
            </ListItemButton>
            {/* <IconButton aria-label="expand row" size="small"    >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton> */}
           
            <ListItemText className={classes.shiptext}>
             {rows.shipName}
             </ListItemText>
             <ListItemIcon className={classes.shipIcon}>
            <IconButton aria-label="expand row" size="small" onClick={handleClick}  >
              {open ?< RemoveIcon/> : <AddIcon/> }
            </IconButton>
            </ListItemIcon>
        </ListItem>
        </Box>

        <Collapse in={open} timeout="auto" unmountOnExit>
          {rows.equimentList.map((data, index) => {
            debugger
            const indexTrans = selectedEquimentKey.indexOf(data.equimentId);

            return (
              <ListItem className={clsx(classes.shiplist, "shiplist", "")}
                button >

                <ListItemText textAlign="left" key={`${rows.equimentName}_${index}`}
                  onClick={(e) => { transformerSelectedId(data.equimentId, data, rows) }}
                  className={clsx(indexTrans > -1 ? classes.active : classes.Inactive, classes.listBox)}
                  selected={indexTrans > -1 ? true : false}
                >
                  {data.equimentName}
                </ListItemText>
              </ListItem>
                
            )
          })}
        </Collapse>
      </Box>

    </div>
  );
}
